module.exports = __webpack_public_path__ + "2e3325a300c7a4be200b2c8b8bad30d2.svg";